module.exports = __webpack_public_path__ + "img/home.c32d7fca.png";